import PropTypes from 'prop-types';
import UITag from 'UIComponents/tag/UITag';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PublicAccessRuleTypes } from '../constants/PublicAccessRuleTypes';
import { getContentAccessTypeTagI18nKeyFromContent } from '../utils/contentAccessTypeTag';
import { jsx as _jsx } from "react/jsx-runtime";
function ContentAccessTypeTag({
  shouldRender,
  password,
  publicAccessRules,
  publicAccessRulesEnabled,
  isSSOEnabled,
  className
}) {
  const {
    i18nKey: contentAccessTypeTagI18nKey
  } = getContentAccessTypeTagI18nKeyFromContent({
    password,
    publicAccessRules,
    publicAccessRulesEnabled,
    isSSOEnabled
  });
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/_jsx(UITag, {
    className: className,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: contentAccessTypeTagI18nKey
    })
  });
}
ContentAccessTypeTag.propTypes = {
  shouldRender: PropTypes.bool.isRequired,
  password: PropTypes.string,
  publicAccessRules: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.oneOf(Object.values(PublicAccessRuleTypes)).isRequired,
    ids: PropTypes.arrayOf(PropTypes.number).isRequired,
    wallPreviewEnabled: PropTypes.bool
  })).isRequired,
  publicAccessRulesEnabled: PropTypes.bool,
  isSSOEnabled: PropTypes.bool,
  className: PropTypes.string
};
export default ContentAccessTypeTag;